import React, { useEffect, useRef, useState } from "react";
import { Button, Typography, Flex } from "antd";
import { SMS_CODE_RETRY_DELAY_IN_SECONDS } from "utils/envConstants";
import styles from "./otpTimeLeft.module.css";

interface OtpTimeLeftProps {
  onResend: () => void;
  loading?: boolean;
  className?: string;
  buttonText?: string;
  countdownText?: string;
  shouldStartCountdown?: boolean;
}

export const OtpTimeLeft: React.FC<OtpTimeLeftProps> = ({
  onResend,
  loading = false,
  className = "",
  buttonText = "Получить новый код",
  countdownText = "Получить новый код через",
  shouldStartCountdown = false,
}) => {
  const [timeLeft, setTimeLeft] = useState<number>(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const clearCountdown = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const startCountdown = () => {
    clearCountdown();
    setTimeLeft(SMS_CODE_RETRY_DELAY_IN_SECONDS);

    intervalRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        const next = prev - 1;
        if (next <= 0) {
          clearCountdown();
          return 0;
        }
        return next;
      });
    }, 1000);
  };

  useEffect(() => {
    if (shouldStartCountdown) {
      startCountdown();
    } else {
      clearCountdown();
      setTimeLeft(0);
    }

    return () => clearCountdown();
  }, [shouldStartCountdown]);

  const handleResend = () => {
    onResend();
    startCountdown();
  };

  return (
    <Flex vertical align="center" className={`${styles.container} ${className}`}>
      {timeLeft > 0 ? (
        <Typography.Text strong className={styles.countdownText}>
          {countdownText} {timeLeft} сек
        </Typography.Text>
      ) : (
        <Button type="default" onClick={handleResend} className="full-width" disabled={loading}>
          {buttonText}
        </Button>
      )}
    </Flex>
  );
};
